import React from "react"
import monster3 from "../../assets/images/products/monster3.png"
import { ProductType } from "./ProductList";
import { getProductNutshellDescription } from "./KeyFeaturesList";
import { Trans, useTranslation } from '../../plugins/i18next/ea-react-i18next';

const ProductNutshell: React.FC<{ product: ProductType }> = ({ product }) => {

  const productItem = getProductNutshellDescription(product);
  const { t } = useTranslation("components", { keyPrefix: 'products.productNutshell' });

  const bulletPoints = t(`${product}.items`, { returnObjects: true }) as string[];
    
  return (
    <div id="bookDemo" className={`subscribe-area ptb-70 product ${product}`}>
      <div className="container-fluid hero-container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-12">
            <div className="subscribe-content">
              <h2>{t("title")}</h2>
              <p>{(<Trans t={t}>{t(`${product}.intro`)}</Trans>)}</p>
              <ul>
                {bulletPoints.map((point, index) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
              <p>{t(`${product}.callToAction`)}</p>
            </div>
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="subscribe-image">
              <img
                src={monster3}
                alt="subscribe"
                className="product-monster-image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductNutshell
